class FileConverterComponent {
  constructor() { }

  setFile( rawFile, encFile ) {

    if (typeof this.fileSelected == 'function'){
      this.fileSelected({rawFile, encFile});
    }
  }

  formatAcceptedFormats(){
    return this.acceptedFormats
      .split('.').join('')
      .split(',').join(', ');
  }
}

export default {
  bindings: {
    fileSelected: "&",
    acceptedFormats: "@",
    outputFormat: "@?",
    uploaderAsBtn: "@"
  },
  templateUrl: "form-builder/utilities/file-converter/file-converter/file-converter.component.html",
  controller: FileConverterComponent
}
